import http from '@libs/http';
import { NewsQuery } from '@libs/api-reference';

import { TSE_API } from './endpoints';

export function getNewsList(
  params: Record<string, any>,
  queryParams?: string | undefined
) {
  return http.get<NewsQuery>(
    `${TSE_API}/observermessages${queryParams ? `?${queryParams}` : ''}`,
    {
      params,
      schema: NewsQuery,
    }
  );
}

export function getNewsItem(id: string) {
  return http.get<NewsQuery>(`${TSE_API}/observermessages/{id}`, {
    urlParams: { id },
    schema: NewsQuery,
  });
}
